export default __webpack_public_path__ + "static/520-e160299cd0ec8de76eff7fe2944858a4.gif";